import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from '../../services/permissions.service';

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;

    componentMapping: Record<SettingsOption, string> = {
        // [SettingsOption.JUDET]: 'app-judet',
        [SettingsOption.CERERE_PRIORITY]: "app-cerere-priority",
        [SettingsOption.STATUS]: "app-status",
        [SettingsOption.REQUEST_TYPES]: "app-request-types",
        [SettingsOption.DOCUMENT_CATEGORY]: "app-document-category",
        [SettingsOption.DOCUMENT_TYPE]: "app-document-type",
        [SettingsOption.DOCUMENT_TEMPLATE]: "app-document-template",
        [SettingsOption.REGISTRE]: "app-registre",
        // [SettingsOption.SEMNATARI]: 'app-semnatari',
        [SettingsOption.OPERATORI]: "app-operatori",
        [SettingsOption.ZILE_LIBERE]: "app-zile-libere",
        [SettingsOption.BORDEROU]: "app-borderou-datatable",
        [SettingsOption.EMAILS_BLACKLIST]: 'app-emails-blacklist',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        // if (
        //   !this.permissionsService.hasPermission(
        //     'autcom-module.settings.judet.list'
        //   )
        // ) {
        //   this.componentKeys = this.componentKeys.filter(
        //     (item) => item !== SettingsOption.JUDET
        //   );
        // }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.prioritati-cerere.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CERERE_PRIORITY
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.status-cerere.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.STATUS
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.tip-cerere.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.REQUEST_TYPES
            );
        }

        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.categorii-documente.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_CATEGORY
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.tip-documente.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_TYPE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.template-documente.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_TEMPLATE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.registre.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.REGISTRE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.operatori.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OPERATORI
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.zile-libere.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.ZILE_LIBERE
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.settings.borderou.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.BORDEROU
            );
        }

        // if (!this.permissionsService.hasPermission('autcom-module.settings.inbox-blacklist.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsOption.EMAILS_BLACKLIST
        //     );
        // }
    }
}
